import React, { useEffect, useContext } from 'react';
import { string, shape } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { Alert } from '@thd-olt-component-react/core-ui';
import { QuantityAdjustmentsContext } from '../QuantityAdjustmentsContext';

export const FulfillmentAlert = ({ product, itemId, podFulFillmentUtils }) => {
  const { itemMap, setItemMap } = useContext(QuantityAdjustmentsContext);
  const { isLocalized } = useStore();
  const { ShipToHome, BOPIS } = podFulFillmentUtils?.getAllFulfillmentInventories(product);
  const availableQty = isLocalized && !ShipToHome ? BOPIS : ShipToHome;

  useEffect(() => {
    if (!itemMap[itemId]?.availableQty) {
      setItemMap({ ...itemMap, [itemId]: { ...itemMap[itemId], availableQty } });
    }
  }, [availableQty]);

  const getAlertTypeProps = () => {
    if (podFulFillmentUtils?.isBackorderedWithDate(product)) {
      const backOrderDate = product?.fulfillment?.backorderedShipDate;
      return { title: 'Backordered', type: 'warning', message: backOrderDate ? `until ${backOrderDate}` : '' };
    }
    if (!availableQty) {
      return { title: 'This product is out of stock', type: 'danger', message: '' };
    }
    if (availableQty < itemMap[itemId]?.selectedQty) {
      return {
        title: '',
        type: 'warning',
        message: `There are only ${availableQty} in stock at this time. Please reduce the quantity to proceed.`
      };
    }
    return null;
  };
  const alertTypeProps = getAlertTypeProps();

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {alertTypeProps ? <Alert inline {...alertTypeProps} /> : <div />}
    </>
  );
};

FulfillmentAlert.propTypes = {
  itemId: string,
  product: shape({}),
  podFulFillmentUtils: shape({})
};

FulfillmentAlert.defaultProps = {
  itemId: '',
  product: {},
  podFulFillmentUtils: {}
};

FulfillmentAlert.displayName = 'FulfillmentAlert';
